import HorizontalLinearStepper from "@/views/elements/HorizontalLinearStepper"
import WrapperModal, { PropsTypeWrapperModal } from "@/views/elements/WrapperModal"
import { useState } from "react"
import Step1 from "./Step1"
import Step2 from "./Step2"
import Step3 from "./Step3"

import { getFirstCharacterName } from "@/utilities"
import { Avatar } from "@mui/material"
import { Box, Stack } from "@mui/system"
import { produce } from "immer"
import RenderRank from "../../ShareMasterFollower/RenderRank"
import { DataOnParents, KeyDataParents } from "../RegisterFollower/RegisterFollower"
import TypographyElement from "@/views/elements/typography/TypographyElement"
import { useTranslation } from "react-i18next"
import { InitVerifyData, VerifyData } from "@/controllers/gridManager/accountsManager/accountManager"
type Props = {}

export default function Withdraw({ open, title, handleClose, data, triggerReload }: PropsTypeWrapperModal) {
    const { t } = useTranslation()
    const { dataMasterTrade } = data

    // console.log('ha_check_dataMasterTrade', dataMasterTrade);
    const steps = [t("copytrade.common.info"), t("copytrade.common.confirm"), t("copytrade.common.complete")]

    const [activeStep, setActiveStep] = useState<number>(0)
    const [dataOnParents, setDataOnParents] = useState<DataOnParents>({
        Step1: {

        },
        Step2: {

        },
        Step3: {

        },
        dataVerify: InitVerifyData
    })

    const handleSaveDataOnParents = (key: KeyDataParents, data: {}) => {
        console.log('ha_check_handleSaveDataOnParents', { key, data });
        setDataOnParents(
            produce((draft) => {
                if (key === "dataVerify") {
                    draft['dataVerify'] = data as VerifyData
                } else {
                    draft[key] = data
                }
            })
        );
    }

    const handleBackStep = () => {
        if (activeStep !== 0) {
            setActiveStep(prevStep => prevStep - 1)
        }
    }

    const handleNextStep = () => {
        setActiveStep(prevStep => prevStep + 1)
    }

    const handleCloseAndReload = () => {
        triggerReload && triggerReload()
        handleClose()
    }

    const currentStep = activeStep + 1

    const renderHeader = () => {
        if (currentStep !== 1) return null
        return (
            <Stack direction={'column'} spacing={2}>
                <Stack direction={'row'} spacing={2}>
                    <Avatar >{getFirstCharacterName(dataMasterTrade?.mt_fullname)}</Avatar>
                    <Stack direction={'column'} spacing={0.25}>
                        <TypographyElement FontWeightElement={700} FontSizeElement="16px">{dataMasterTrade?.mt_fullname}</TypographyElement>
                        <RenderRank rank={"M"} sx={{ width: "fit-content" }} />
                    </Stack>
                </Stack>

                <Box sx={{ borderTop: "1px solid ", height: 20, borderColor: 'text.secondary' }}></Box>
            </Stack>
        )
    }

    return (
        <WrapperModal
            open={open}
            handleClose={handleClose}
            title={t("copytrade.withdraw.title")}
            customHeader={renderHeader()}
        >
            <HorizontalLinearStepper
                steps={steps}
                activeStep={activeStep}
                setActiveStep={setActiveStep}
            />

            {
                currentStep === 1 && <Step1
                    close={handleClose}
                    back={handleBackStep}
                    next={handleNextStep}
                    handleSaveDataOnParents={handleSaveDataOnParents}
                    dataOnParents={dataOnParents}
                    data={data}
                />
            }

            {
                currentStep === 2 && <Step2
                    close={handleClose}
                    back={handleBackStep}
                    next={handleNextStep}
                    handleSaveDataOnParents={handleSaveDataOnParents}
                    dataOnParents={dataOnParents}
                    data={data}
                />
            }

            {
                currentStep === 3 && <Step3
                    close={handleCloseAndReload}
                />
            }

        </WrapperModal>
    )
}